import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
// CTA al Motor de Diagnostico. Se AGREGA al hero sin sustituir los CTAs
// existentes; trae su propio estilo aislado para no tocar LHero.css.
import DiagnosticoHeroCTA from '../shared/DiagnosticoHeroCTA';
import './LHero.css';

function LHero() {
  
  // --- CONTEO ANIMADO ---
  const [studentCount, setStudentCount] = useState(0);
  const [conversationCount, setConversationCount] = useState(0);
  const [rating, setRating] = useState(0.0);

  const statsRef = useRef(null);
  const animationPlayed = useRef(false);

  const animateCount = (target, setter, isDecimal = false, duration = 2000) => {
    let start = 0;
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      
      const easeOut = 1 - Math.pow(1 - (progress / duration), 3);
      let current = start + (target - start) * easeOut;

      if (progress >= duration) {
        current = target;
      }

      if (isDecimal) {
        setter(parseFloat(current.toFixed(1)));
      } else {
        setter(Math.floor(current));
      }

      if (progress < duration) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && !animationPlayed.current) {
        animationPlayed.current = true;
        
        animateCount(500, setStudentCount); // Cambiado a 500
        animateCount(500, setConversationCount); // 500K conversaciones
        animateCount(4.9, setRating, true);

        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);
  
  // --- FIN CONTEO ANIMADO ---

  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="lp-container">
        <div className="hero-content">
          <div className="hero-badge">
            ✨ "Entrena <span className="hero-badge-highlight">hoy</span> habla <span className="hero-badge-highlight">hoy</span>"
          </div>
          <h1 className="hero-h1">
            Entiendes ingles pero<br />no puedes <span className="highlight">hablarlo</span>
          </h1>
          <p className="hero-subtitle">
            Únete a la comunidad NSL y transforma tu manera de comunicarte.
            Con nuestras clases personalizadas y plataforma con tutor de IA, el inglés dejará de ser un desafío para convertirse en tu fortaleza.
          </p>
          <div className="hero-cta-container">
            <Link to="/register" className="hero-cta">Pruebalo GRATIS ahora</Link>
            <button className="hero-cta-secondary" onClick={scrollToPricing}>Ver Planes</button>
          </div>

          <DiagnosticoHeroCTA />
          
          <div className="hero-stats" ref={statsRef}>
            <div className="stat">
              <span className="stat-number">+{studentCount.toLocaleString('es-MX')}</span>
              <span className="stat-label">Estudiantes activos</span>
            </div>
            <div className="stat">
              <span className="stat-number">{conversationCount.toLocaleString('es-MX')}k</span>
              <span className="stat-label">Conversaciones</span>
            </div>
            <div className="stat">
              <span className="stat-number">{rating.toFixed(1)}</span>
              <span className="stat-label">⭐⭐⭐⭐⭐ Rating</span>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default LHero;